// extracted by mini-css-extract-plugin
export default {"link":"Link_link__EsFuj","icon":"Link_icon__96n1a","disabled":"Link_disabled__pou6o","error-text":"Link_error-text__BYtlK"};